import React, { useContext } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
//Component
import Loading from "@components/Loading";
//Routes
import Home from "@pages/Home";
import NewPQRS from "@pages/NewPQRS";
import Layout from "@components/Layout";
import ViewPQRS from "@pages/ViewPQRS";
import NotFound from "@pages/NotFound";
//Styles
import "react-toastify/dist/ReactToastify.css";
import { AppContext } from "@context";

const App = () => {
  const { state, dispatch } = useContext(AppContext);
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/view" component={ViewPQRS} />

        <Route exact path="/" component={Home} />
        <Route exact path="/create" component={NewPQRS} />
        <Route component={NotFound} />
      </Switch>
      {state.loading && <Loading />}
      <ToastContainer />
    </BrowserRouter>
  );
};

export default App;
